/* eslint-disable */
import { useContext } from 'react'
import '../../globalStyle.scss'
import { useTranslation } from 'react-i18next'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderLabel, getProviderRole } from '../../utils/provider'
import DashboardDataList from './DashboardDataList'
import { dateToLocal } from './dateHelpler'
import { titleStyle } from './commonStyle'

function LatestIndicatorDataList({ isLoading, data }: any) {
  const { t } = useTranslation()
  const { customerId } = useContext(OrgAppContext)
  const providerRole = getProviderRole(customerId)

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 0.8,
      valueFormatter: (params: any) => {
        const date = new Date(params.value)
        return dateToLocal(date)
      },
    },
    {
      field: 'type',
      headerName: 'Category',
      flex: 2,
      valueFormatter: (params: any) => {
        return t(`alertType.${params.value}`, { providerRole })
      },
    },
    { field: 'providerId', headerName: getProviderLabel(customerId, 'id'), flex: 0.8 },
    { field: 'name', headerName: getProviderLabel(customerId, 'name'), flex: 1.5 },
    {
      field: 'riskLevel',
      headerName: 'Risk',
      flex: 0.6,
    },
  ]

  return (
    <div>
      <div style={titleStyle}>Latest 20 indicators</div>
      <DashboardDataList isLoading={isLoading} data={data} columns={columns} />
    </div>
  )
}

export default LatestIndicatorDataList
